module.exports = __webpack_public_path__ + "static/media/party-catering-4.b7e81b16.jpg";